<template>
    <div class="circle">
        <div class="circle-left">
            <div class="left" :style="circleLeftStyle"></div>
        </div>
        <div class="circle-right">
            <div class="right" :style="circleRightStyle"></div>
        </div>
        <div class="mask">
            <span class="mask-text">{{percent}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['percent'],
        data() {
            const percent_num = this.percent.split('%')[0] * 3.6 || 0;
            let circleLeftStyle = null;
            let circleRightStyle = null;
            if (percent_num <= 180) {
                circleRightStyle = {
                    transform: `rotate(${percent_num}deg)`
                }
            } else {
                circleLeftStyle = {
                    transform: `rotate(${percent_num - 180}deg)`
                };
                circleRightStyle = {
                    transform: `rotate(182deg)`
                }
            }
            return {
                circleLeftStyle,
                circleRightStyle
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/sass/mixin.scss";

    $size: 160px;
    $size_mask: 120px;

    .circle {
        width: $size;
        height: $size;
        position: relative;
        border-radius: 50%;
        background: $color_a;
        .circle-left,
        .circle-right {
            width: $size;
            height: $size;
            position: absolute;
            top: 0;
            left: 0;
        }
        .left,
        .right {
            display: block;
            width: $size;
            height: $size;
            background: $color_9;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: 0;
            transform: rotate(0deg);
        }
        .circle-right, .right {
            clip: rect(0, auto, auto, $size/2);
        }
        .circle-left, .left {
            clip: rect(0, $size/2, auto, 0);
        }
    }

    .mask {
        width: $size_mask;
        height: $size_mask;
        border-radius: 50%;
        left: $size/2-$size_mask/2;
        top: $size/2-$size_mask/2;
        background: #FFF;
        position: absolute;
        text-align: center;
        line-height: $size_mask;
        font-size: 16px;
        .mask-text {
            font-weight: bold;
            font-size: 40px;
            color: $color_4;
        }
    }

</style>
